import React from 'react';
import { useLocation } from '@tanstack/react-router';

type SingleColumnProps = {
  /**
   * 表示するコンテンツ
   */
  children: React.ReactNode;
  /**
   * コンテナに適用するスタイル
   */
  style?: React.CSSProperties;
  /**
   * コンテンツに適用するスタイル
   */
  contentStyle?: React.CSSProperties;
  /**
   * コンテナに適用するクラス名
   */
  className?: string;
  /**
   * コンテンツに適用するクラス名
   */
  contentClassName?: string;
  /**
   * 初期設定を保存するためのID
   */
  layoutId?: string;
};

/**
 * 単一カラムレイアウトコンポーネント
 *
 * シンプルで高度にカスタマイズ可能なレイアウト
 */
const SingleColumn: React.FC<SingleColumnProps> = ({
  children,
  style = {},
  contentStyle = {},
  className = '',
  contentClassName = '',
  layoutId,
}) => {
  const location = useLocation();
  // layoutIdが指定されていなければルートパスを使用
  const storeKey = layoutId || location.pathname;

  return (
    <div
      className={`single-column-container w-full h-full ${className}`}
      style={{ ...style }}
      data-layout-id={storeKey}
    >
      <div
        className={`single-column-content h-full ${contentClassName}`}
        style={{ ...contentStyle }}
      >
        {children}
      </div>
    </div>
  );
};

export default SingleColumn;
